/*
 * Bonvelle · Rhode-laag: verlanglijst in de browser (localStorage), zonder account.
 * - [data-rh-hart="<handle>"] zet een product op of van de lijst (aria-pressed toont de stand).
 * - [data-rh-wl-aantal] toont het aantal.
 * - [data-rh-wishlist] (pagina /pages/wishlist) toont de lijst als Rhode-kaarten.
 * Lukt localStorage niet (privévenster, geblokkeerd), dan werkt het hartje alleen voor deze pagina.
 */
(() => {
  const SLEUTEL = 'rh-wishlist';
  let geheugen = [];
  const lees = () => {
    try {
      const l = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
      return Array.isArray(l) ? l : [];
    } catch {
      return geheugen;
    }
  };
  const schrijf = (l) => {
    geheugen = l;
    try {
      localStorage.setItem(SLEUTEL, JSON.stringify(l));
    } catch {}
  };

  const zet = () => {
    const l = lees();
    document.querySelectorAll('[data-rh-hart]').forEach((b) => {
      const aan = l.includes(b.dataset.rhHart);
      if (b.getAttribute('aria-pressed') !== String(aan)) b.setAttribute('aria-pressed', String(aan));
    });
    const tekst = l.length ? `(${l.length})` : '';
    // Alleen schrijven bij verschil: anders ziet de MutationObserver hieronder een wijziging en
    // blijft hij elk frame opnieuw zetten.
    document.querySelectorAll('[data-rh-wl-aantal]').forEach((e) => {
      if (e.textContent !== tekst) e.textContent = tekst;
    });
  };

  document.addEventListener('click', (e) => {
    const b = e.target instanceof Element ? e.target.closest('[data-rh-hart]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    const l = lees();
    const h = b.dataset.rhHart;
    const i = l.indexOf(h);
    if (i >= 0) l.splice(i, 1);
    else l.unshift(h);
    schrijf(l.slice(0, 60));
    zet();
    if (pagina && i >= 0) toonPagina();
  });

  // Horizon herrendert delen van de pagina bij een variantwissel: daarna de stand opnieuw zetten.
  let gepland = false;
  new MutationObserver(() => {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(() => {
      gepland = false;
      zet();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Zelfde koppeling als snippets/rh-woord.liquid: eerste passende tag, anders het laatste titelwoord.
  const WOORDEN = "Kettingen:ketting|Medaillons:medaillon|Armbanden:armband|Bedels:bedel|Horloges:horloge|Geboortesteenringen:ring|Belofteringen:ring|Reisringen:ring|Fidget Ringen:ring|Ringen:ring|Draaiende Rozendozen:rozen|Eeuwige Rozen:rozen|Zelfmaakpakketten:pakket|Cadeaubundels:cadeau|Jurken:jurk|Broeken & jeans:broek|Schoenen:schoen|Tops & blouses:top|Hoodies & joggers:hoodie|Jassen & blazers:jas|Jumpsuits & sets:set|Nachtkleding:nachtmode|Nachtmode & loungewear:nachtmode|Zwemkleding:badmode|Sport & Yoga:sport|Sokken:sokken|Accessoires:accessoire|Naadloze bh's:bh|Push-up bh's:bh|BH's:bh|Bralettes & bratops:bralette|Bodysuits:body|Shapewear:shapewear|Naadloze slips:slip|Slips & ondergoed:slip|Zwangerschap & Voeding:voeding|Sets:set|Heren:heren".split('|').map((p) => p.split(':'));
  const woordVan = (p) => {
    const tags = p.tags || [];
    const hit = WOORDEN.find(([tag]) => tags.includes(tag));
    return hit ? hit[1] : (p.title || '').split(' ').pop().toLowerCase();
  };

  const pagina = document.querySelector('[data-rh-wishlist]');
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const geld = (centen) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(centen / 100);
  const beeld = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');

  const kaart = (p) => `
    <article class="rh-pkaart">
      <a class="rh-pkaart__link" href="/products/${esc(p.handle)}">
        <span class="rh-pkaart__woord" aria-hidden="true">${esc(woordVan(p))}</span>
        <span class="rh-pkaart__beeld">${p.featured_image ? `<img class="rh-pkaart__img" src="${esc(beeld(p.featured_image, 800))}" alt="${esc(p.title)}" loading="lazy">` : ''}</span>
        <span class="rh-pkaart__info">
          <span class="rh-pkaart__rij"><span class="rh-pkaart__naam">${esc(p.title)}</span><span class="rh-pkaart__prijs">${esc(geld(p.price))}</span></span>
        </span>
      </a>
      <button type="button" class="rh-hartje" data-rh-hart="${esc(p.handle)}" aria-pressed="true" aria-label="${esc(p.title)} van je verlanglijst halen">
        <svg width="20" height="18" viewBox="0 0 20 18" aria-hidden="true" focusable="false"><path d="M10 16.8S2.3 12.1.9 7.5C-.1 4.2 2.2 1 5.6 1 7.6 1 9.1 2.1 10 3.6 10.9 2.1 12.4 1 14.4 1c3.4 0 5.7 3.2 4.7 6.5C17.7 12.1 10 16.8 10 16.8Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>
      </button>
    </article>`;

  const toonPagina = async () => {
    const l = lees();
    const raster = pagina.querySelector('[data-rh-wl-raster]');
    const leeg = pagina.querySelector('[data-rh-wl-leeg]');
    const verder = pagina.querySelector('[data-rh-wl-verder]');
    leeg.hidden = l.length > 0;
    verder.hidden = false;
    const producten = await Promise.all(
      l.map((h) => fetch(`/products/${encodeURIComponent(h)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null))
    );
    const gevonden = producten.filter(Boolean);
    raster.innerHTML = gevonden.map(kaart).join('');
    if (!gevonden.length) leeg.hidden = false;
    zet();
  };

  zet();
  if (pagina) toonPagina();
})();
